import Image from "next/image";
import img1 from "@/asset/images/client/1.png";
import img2 from "@/asset/images/client/2.png";
import img3 from "@/asset/images/client/3.png";
import img4 from "@/asset/images/client/4.png";
import img5 from "@/asset/images/client/5.png";
import img6 from "@/asset/images/client/6.png";
import img7 from "@/asset/images/client/7.png";
import img8 from "@/asset/images/client/8.png";

export default function ClientsSection() {
  const clients = [
    { name: "Client 1", logo: img1.src },
    { name: "Client 2", logo: img2.src },
    { name: "Client 3", logo: img3.src },
    { name: "Client 4", logo: img4.src },
    { name: "Client 5", logo: img5.src },
    { name: "Client 6", logo: img6.src },
    { name: "Client 7", logo: img7.src },
    { name: "Client 8", logo: img8.src },
  ];

  return (
    <section className='min-h-[600px] flex items-center justify-center'>
      <div className='max-w-7xl mx-auto w-full'>
        <div className='text-center mb-2 md:mb-4'>
          <h2 className='text-[24px] md:text-[40px] lg:text-[68px] font-bold mb-2 lg:mb-10'>
            Our Trusted Clients
          </h2>
          <p className='text-base md:text-[20px] lg:text-[24px] mx-auto px-4'>
            Trusted by more than{" "}
            <span className='text-[#443DFF] font-semibold'>
              100
            </span>{" "}
            leading names in both Web3 and Web2
          </p>
        </div>

        <div className='grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 items-center'>
          {clients.map((client, index) => (
            <div
              key={index}
              className='flex justify-center items-center p-2 lg:p-4 hover:shadow-lg transition-shadow duration-300 rounded-lg'>
              <Image
                src={client.logo}
                alt={client.name}
                width={230}
                height={150}
                className='w-full max-w-[150px] md:max-w-[200px] lg:max-w-[225px] h-auto object-cover bg-left bg-no-repeat'
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
